import gql from "graphql-tag";

export const LOGIN_MUTATION = gql`
  mutation LoginUser(
    $username: String!
    $password: String!
    $wishlist: [Int]
    $deviceId: [String]
  ) {
    login(
      input: {
        clientMutationId: "login-mutation"
        username: $username
        password: $password
        wishlist: $wishlist
        deviceId: $deviceId
      }
    ) {
      authToken
      refreshToken
      message
      showPrice
      showCategories {
        id
        databaseId
        name
        slug
        termGroupId
        description
        parentId
        count
        menuOrder
      }
      showPriceCategories {
        id
        databaseId
        name
        slug
        termGroupId
        description
        parentId
        count
        menuOrder
      }
      user {
        id
        name
        email
        userId
        lastName
        username
        firstName
        showPrice
        showCategories {
          id
          databaseId
          name
          slug
          termGroupId
          description
          parentId
          count
          menuOrder
        }
        showPriceCategories {
          id
          databaseId
          name
          slug
          termGroupId
          description
          parentId
          count
          menuOrder
        }
      }
    }
  }
`;

export interface RegisterProps {
  first_name: string;
  last_name: string;
  email: string;
  email_confirmation: string;
  company: string;
  address: string;
  city: string;
  // postcode: string;
  country: string;
  phone: string;
  birthday: string;
  gender: string;
  deviceId: string;
  jobPosition: string;
  // vat: string;
}

export interface RegisterResults {
  registerCustomer: {
    clientMutationId: string;
    authToken: string;
    refreshToken: string;
    customer: {
      id: string;
      displayName: string;
      email: string;
      databaseId: number;
      lastName: string;
      username: string;
      firstName: string;
    };
  };
}

export const REGISTER_MUTATION = gql`
  mutation register(
    $firstname: String
    $lastname: String
    $municipality: String
    $address: String
    $password: String
    $telephone: String
    $email: String!
    $country: String
    $jobPosition: String
    # $vat: String
    $gender: String
    $deviceId: [String]
    $fcmToken: String
    $birthday: String
    # $postcode: String
    $company: String
  ) {
    registerCustomer(
      input: {
        clientMutationId: "register-mutation"
        username: $email
        firstName: $firstname
        lastName: $lastname
        email: $email
        shippingSameAsBilling: true
        password: $password
        jobPosition: $jobPosition
        # vat: $vat
        gender: $gender
        deviceId: $deviceId
        fcmToken: $fcmToken
        birthday: $birthday
        country: $country
        billing: {
          firstName: $firstname
          lastName: $lastname
          address1: $address
          city: $municipality
          phone: $telephone
          # postcode: $postcode
          company: $company
        }
      }
    ) {
      authToken
      refreshToken
      clientMutationId
      customer {
        id
        displayName
        email
        databaseId
        lastName
        username
        firstName
      }
    }
  }
`;

export interface ForgotPasswordProps {
  username: string;
}

export interface ForgotPasswordResults {
  clientMutationId: string;
}

export const FORGOT_PASSWORD_MUTATION = gql`
  mutation ForgotPassword($username: String!) {
    sendPasswordResetEmailprofiti(
      input: { clientMutationId: "forgot-password", username: $username }
    ) {
      clientMutationId
    }
  }
`;

export interface ResetPasswordProps {
  key: string;
  login: string;
  password: string;
}

export interface ResetPasswordResults {
  clientMutationId: string;
}

export const RESET_PASSWORD_MUTATION = gql`
  mutation ResetPassword($key: String!, $login: String!, $password: String!) {
    resetUserPassword(
      input: {
        clientMutationId: "reset-password"
        key: $key
        login: $login
        password: $password
      }
    ) {
      clientMutationId
    }
  }
`;

export const UPDATE_PROFILE = gql`
  mutation updateProfileMutation(
    $id: ID!
    $firstName: String
    $lastName: String
  ) {
    updateCustomer(
      input: {
        id: $id
        firstName: $firstName
        lastName: $lastName
        clientMutationId: "update-customer-profile"
      }
    ) {
      customer {
        firstName
        lastName
      }
    }
  }
`;

export const UPDATE_ADDRESS_MUTATION = gql`
  mutation updateAddressMutation(
    $id: ID!
    $billingFirstName: String
    $billingLastName: String
    $billingCity: String
    $billingCountry: CountriesEnum
    $billingAddress: String
    $billingPhone: String
    $shippingFirstName: String
    $shippingLastName: String
    $shippingCity: String
    $shippingCountry: CountriesEnum
    $shippingAddress: String
  ) {
    updateCustomer(
      input: {
        clientMutationId: "customer-update-mutation"
        id: $id
        billing: {
          firstName: $billingFirstName
          lastName: $billingLastName
          city: $billingCity
          address1: $billingAddress
          phone: $billingPhone
          country: $billingCountry
        }
        shipping: {
          firstName: $shippingFirstName
          lastName: $shippingLastName
          city: $shippingCity
          address1: $shippingAddress
          country: $shippingCountry
        }
      }
    ) {
      customer {
        billing {
          address1
          city
          firstName
          lastName
          phone
          country
        }
        shipping {
          address1
          city
          firstName
          lastName
          phone
          country
        }
      }
    }
  }
`;

export const UPDATE_PROFILE_PASSWORD_MUTATION = gql`
  mutation updateProfilePasswordMutation($id: ID!, $password: String) {
    updateUser(
      input: {
        id: $id
        password: $password
        clientMutationId: "update-profile-password-mutation"
      }
    ) {
      clientMutationId
    }
  }
`;

export const REMOVE_ITEM_FROM_WISHLIST = gql`
  mutation removeItemFromWishlist($id: Int, $userID: Int) {
    removeFromWishlist(
      input: {
        clientMutationId: "remove-item-from-wishlist"
        id: $id
        userID: $userID
      }
    ) {
      message
    }
  }
`;

export const ADD_ITEM_TO_WISHLIST = gql`
  mutation addItemFromWishlist($ids: [Int], $userId: Int) {
    addToWishlist(
      input: {
        clientMutationId: "add-item-to-wishlist"
        ids: $ids
        userID: $userId
      }
    ) {
      message
    }
  }
`;
